import Splide from "@splidejs/splide";

// Use different init functions so that we can customize individually if needed.

initBanner();
initCards();
initSocialEmbeds();
initProducts();
initProductImages();

function initBanner() {
  document.querySelectorAll("[data-splide-banner]").forEach((el) => {
    const splide = new Splide(el, {
      type: "fade",
      arrows: false,
      pagination: true,
      lazyLoad: "nearby",
    });

    splide.mount();
  });
}

function initCards() {
  document.querySelectorAll("[data-splide-cards]").forEach((el) => {
    const splide = new Splide(el, {
      autoWidth: true,
      arrows: true,
      pagination: true,
      focus: "center",
      omitEnd: true,
    });

    splide.mount();
  });
}

function initSocialEmbeds() {
  document.querySelectorAll("[data-splide-social-embeds]").forEach((el) => {
    const splide = new Splide(el, {
      autoWidth: true,
      arrows: false,
      pagination: true,
      focus: "center",
      omitEnd: true,
    });

    splide.mount();
  });
}

function initProducts() {
  document.querySelectorAll("[data-splide-recipes]").forEach((el) => {
    const splide = new Splide(el, {
      autoWidth: true,
      arrows: true,
      pagination: true,
      focus: "center",
      omitEnd: true,
    });

    splide.mount();
  });
}

function initProductImages() {
  document.querySelectorAll("[data-splide-product-images]").forEach((el) => {
    const main = el.querySelector("[data-splide-product-images-main]");
    const thumbs = el.querySelector("[data-splide-product-images-thumbs]");

    if (!main) return;

    const splideMain = new Splide(main, {
      type: "fade",
      arrows: false,
      pagination: false,
      rewind: true,
      drag: false,
    });

    if (thumbs) {
      const splideThumbs = new Splide(thumbs, {
        arrows: true,
        pagination: false,
        isNavigation: true,
        perPage: 3,
      });

      splideMain.sync(splideThumbs);
      splideMain.mount();
      splideThumbs.mount();

      window.addEventListener("product-gallery-close", (event) => {
        const index = event.detail.index;

        splideMain.go(index);
      });
    } else {
      splideMain.mount();
    }
  });
}
